import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { SearchMerchantSchemasSuccess } from '../actions/create-new.actions';
import {
  CompanyLogoUpdateSuccess,
  EmailChanged,
  FirstNameChanged,
  HasLoyaltyFlagChanged,
  LastNameChanged,
  MerchantNameChanged,
  SelectedSchemaChanged,
  UpdateMerchant,
  WebsiteURLChanged,
} from '../actions/general.actions';
import { SearchMerchantSuccess } from '../actions/summary.actions';
import { MerchantGeneralState } from '../models/merchant.model';

const initialState: MerchantGeneralState = {
  merchantLogoUrl: '',
  merchant: '',
  firstName: '',
  lastName: '',
  companyName: '',
  websiteURL: '',
  email: '',
  mobileNumber: '',
  vatNumber: '',
  merchantConfig: '',
  hasLoyaltyFlag: false,
  schemas: [],
  selectedSchema: '',
  submit: false,
};

export const MerchantGeneralReducer = createReducer(
  initialState,
  on(FirstNameChanged, (state, { firstName }) => ({
    ...state,
    firstName,
  })),
  on(LastNameChanged, (state, { lastName }) => ({
    ...state,
    lastName,
  })),
  on(MerchantNameChanged, (state, { companyName }) => ({
    ...state,
    companyName,
  })),
  on(WebsiteURLChanged, (state, { websiteURL }) => ({
    ...state,
    websiteURL,
  })),
  on(EmailChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(HasLoyaltyFlagChanged, (state, { hasLoyaltyFlag }) => ({
    ...state,
    hasLoyaltyFlag,
  })),
  on(SelectedSchemaChanged, (state, { selectedSchema }) => ({
    ...state,
    selectedSchema,
  })),
  on(UpdateMerchant, (state) => ({
    ...state,
    submit: true,
  })),
  on(SearchMerchantSchemasSuccess, (state, { schemas }) => ({
    ...state,
    schemas,
  })),
  on(SearchMerchantSuccess, (state, { res }) => ({
    ...state,
    merchantLogoUrl: res.payload?.data?.merchantConfig?.brandLogo,
    merchant: res.payload?.data,
    firstName: res.payload?.data?.firstName,
    lastName: res.payload?.data?.lastName,
    mobileNumber: res.payload?.data?.merchantTelephones.filter((tel: any) => tel.primary)[0]?.telephoneNumber ?? '',
    companyName: res.payload?.data?.companyName,
    websiteURL: res.payload?.data?.merchantConfig ? res.payload.data.merchantConfig.website : '',
    email: res.payload?.data?.merchantEmails.filter((email: any) => email.primary)[0]?.emailAddress ?? '',
    vatNumber: res.payload?.data?.vatNumber,
    hasLoyaltyFlag: res.payload?.data?.hasLoyaltyFlag,
    selectedSchema: res.payload?.data?.loyaltySchemaCode,
  })),
  on(CompanyLogoUpdateSuccess, (state, { res }) => ({
    ...state,
    merchantLogoUrl: res.payload.data.fileUrl,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => {
    if (activeComponent === 'MerchantSummaryComponent' || activeComponent === 'MerchantDetailsComponent') {
      return {
        ...state,
      };
    }
    return initialState;
  }),
);
